import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const TicketLoadable = loadable(() => import(/* webpackChunkName: "ticket-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default TicketLoadable;
